import logo from './logo.svg';
import './App.css';
import Login from './Login/Login';
import Navbar from './Navbar/Navbar';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import Home from './Home/Home';
import RedirectCode from './Login/RedirectCode';
import NavbarInternal from './Navbar/NavbarInternal';
import AuthService from './Services/AuthService';
import { useEffect, useState } from 'react';
import Search from './Search/Search';
import Sequences from './Sequences/Sequences';
import SequenceDetail from './Sequences/SequenceDetail';
import BasicNotification from './Notifications/BasicNotification';
import SequenceContacts from './Sequences/SequenceContacts';
import SequenceSettings from './Sequences/SequenceSettings';
import UserProfile from './User/UserProfile';
import SequenceEmails from './Sequences/SequenceEmails';
import PubSub from 'pubsub-js';
import SequenceEmailsLogs from './Sequences/SequenceEmailsLogs';
import SequenceLogs from './Sequences/SequenceLogs';
import NavbarAdmin from './Navbar/NavbarAdmin';
import SequenceSchedule from './Sequences/SequenceSchedule';
import AdminListUsers from './Admin/AdminListUsers';
import AdminProfile from './Admin/AdminProfile';
import AdminLeads from './Admin/Leads/AdminLeads';
import AdminUploadLeads from './Admin/Leads/AdminUploadLeads';
import AdminListLeads from './Admin/Leads/AdminListLeads';
import UserDetail from './Admin/UserDetail';
import AdminSequenceList from './Sequences/AdminSequenceList';
import Signin from './SignIn/SignIn';
import UserNew from './User/UserNew';
import Inbox from './Inbox/Inbox';
import LoadingNotification from './Notifications/LoadingNotification';
import TemplatesList from './Admin/Templates/TemplatesList';
import TemplateDetail from './Admin/Templates/TemplatesDetail';
import SignUp from './SignUp/SignUp';
import AppPasswordStep1 from './AppPassword/AppPasswordStep1';
import AppPasswordStep2 from './AppPassword/AppPasswordStep2';
import AppPasswordStep3 from './AppPassword/AppPasswordStep3';
import SequenceLayout from './Sequences/SequenceLayout';
import AdminEmails from './Admin/AdminEmails';
import AdminLeadAssignationLogs from './Admin/LeadAssignationLogs';
import ForgotPassword from './SignIn/ForgotPassword';
import ResetPassword from './SignIn/ResetPassword';

function App() {

  const [user, setUser] = useState(null);

  const getCurrentUser = async () => {
    console.log(window.location.pathname);
    if (window.location.pathname === '/auth/google/callback') {
      return;
    }

    let user = await AuthService.getCurrentUser();
    setUser(user);
  }

  PubSub.subscribe('login.success', (msg, user) => {
    getCurrentUser();
  });

  useEffect(() => {
    getCurrentUser();
  }, []);

  function renderNavbar() {
    if (user && user.email) {

      if (user.role === 'admin') {
        return <NavbarAdmin />;
      } else {
        return <NavbarInternal />;
      }

    } else {
      return <Navbar />;
    }
  }

  return (
    <div style={{ overflowX: 'hidden', position: 'relative' }}>

      <BrowserRouter>
        {renderNavbar()}

        <BasicNotification />
        <LoadingNotification />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="login" element={<Login />} />
          <Route path="signin" element={<Signin />} />
          <Route path="signup" element={<SignUp />} />
          <Route path="user/profile" element={<UserProfile />} />
          <Route path="search" element={<Search />} />
          <Route path="app-password/step1" element={<AppPasswordStep1 />} />
          <Route path="app-password/step2" element={<AppPasswordStep2 />} />
          <Route path="app-password/step3" element={<AppPasswordStep3 />} />
          <Route path="admin/inbox/*" element={<Inbox />} />
          <Route path="admin/users" element={<AdminListUsers />} />
          <Route path="admin/users/new" element={<UserNew />} />
          <Route path="admin/users/detail/:id" element={<UserDetail />} />
          <Route path="admin/leads" element={<AdminLeads />} />
          <Route path="admin/leads/upload" element={<AdminUploadLeads />} />
          <Route path="admin/leads/list" element={<AdminListLeads />} />
          <Route path="admin/emails" element={<AdminEmails />} />
          <Route path="admin/lead-assignation-logs" element={<AdminLeadAssignationLogs />} />
          <Route path="sequences" element={<Sequences />} />
          <Route path="admin/sequences" element={<AdminSequenceList />} />
          <Route path="admin/templates" element={<TemplatesList />} />
          <Route path="admin/templates/detail/:id" element={<TemplateDetail />} />
          <Route path="sequences/:id/*" element={<SequenceLayout />}> 
            <Route index element={<SequenceDetail />} />
            <Route path="contacts" element={<SequenceContacts />} />
            <Route path="settings" element={<SequenceSettings />} />
            <Route path="logs" element={<SequenceEmailsLogs />} />
            <Route path="sequence-logs" element={<SequenceLogs />} />
            <Route path="emails" element={<SequenceEmails />} />
            <Route path="schedule" element={<SequenceSchedule />} />
          </Route>
          <Route path="auth/google/callback" element={<RedirectCode />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="reset-password" element={<ResetPassword />} />
        </Routes>

      </BrowserRouter>


    </div>
  );
}

export default App;
